import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Card,
  Grid,
  Checkbox,
} from "@material-ui/core";
import "moment/locale/es";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  conveniosGetPracticasConfirmadas,
  conveniosEliminarPracticaActivasNomenclados,
  conveniosEliminarPracticaActivasNomencladosMasivo,
  conveniosEditarNomenclados,
  generateExcelValorizaciones,
  conveniosReactivarPracticaNomenclados,
  generatePDFValorizaciones
} from "../../../actions/contrataciones/contratacionesConvenios";
import BuscadorConvenios from "./BuscadorConvenios";
import { CATEGORIAS_VALORIZACIONES_ARRAY } from "../../../utils/constants";
import DeleteConveniosButton from "./DeleteConveniosButton";
import DeleteConveniosMasivosButton from "./DeleteConveniosMasivosButton";
import EditConveniosButton from "./EditConveniosButton";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import ReactivarConveniosButton from "./ReactivarConveniosButton";
import { TablePaginationActions } from "../../compartidos/TablePaginationActions";
import { makeStyles } from "@material-ui/core/styles";
import { CONTRATACIONES_CONVENIOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from '../../../helpers/permisos';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  rootTableRow: {
    '& > *': {
      borderBottom: 'unset',
    },
  }
}));

export const ConveniosNomencladosPracticasActivas = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const { practicasConfirmadas } = useSelector((state) => state.contratacionesConvenios);
  const { dataContrato } = useSelector((state) => state.contrataciones);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selected, setSelected] = useState([]);
  const [filtroFecha, setFiltroFecha] = useState(2);
  const { permisos: permisosUser } =  useSelector(state => state.auth);

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const handleSelectAllClick = (event) => {
    
    if (event.target.checked && selected.length === 0) {
      const newSelecteds = practicasConfirmadas.filter(s => !(s.fechaReactivacionPermitida !== null && moment(s.fechaReactivacionPermitida).isSame(moment(), 'day'))).map((n) => n.idGalenosGastos);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, idGalenosGastos) => {
    const selectedIndex = selected.indexOf(idGalenosGastos);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, idGalenosGastos);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const deletePracticasActivasMasivasHandler = (fechaFin, eliminacionPerm) => {
    dispatch(conveniosEliminarPracticaActivasNomencladosMasivo(dataContrato.idEfectorFacturacion, selected, fechaFin,
      eliminacionPerm, setSelected));
  };

  const deletePracticasActivasHandler = (idItem, fechaFin, eliminacionPerm) => {
    dispatch(conveniosEliminarPracticaActivasNomenclados(dataContrato.idEfectorFacturacion, idItem, fechaFin,
      eliminacionPerm));
  };

  const reactivarPracticaHandler = (idItem) => {
    dispatch(conveniosReactivarPracticaNomenclados(dataContrato.idEfectorFacturacion, idItem));
  };

  const handleEditPractica = (idItem, data) => {
    dispatch(conveniosEditarNomenclados(dataContrato.idEfectorFacturacion, idItem, data));
  };

  const handleGetPracticas = (tipoDataPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    setSelected([]);
    setFiltroFecha(tipoDataPorFecha);
    dispatch(conveniosGetPracticasConfirmadas(dataContrato?.idEfectorFacturacion, tipoDataPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta));
  }

  useEffect(() => {
    dispatch(
      conveniosGetPracticasConfirmadas(dataContrato.idEfectorFacturacion)
    );
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BuscadorConvenios
          handleSearch={handleGetPracticas}
          handlePrint={handlePrint}
          handleExportExcel={(dataPorFecha) => dispatch(generateExcelValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
          handleGeneratePdf={(dataPorFecha) => dispatch(generatePDFValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
        />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <Table ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={selected.length > 0 && selected.length < practicasConfirmadas.length}
                    checked={practicasConfirmadas.length > 0 && selected.length === practicasConfirmadas.length}
                    onChange={handleSelectAllClick}
                    inputProps={{ "aria-label": "select all desserts" }}
                    disabled={props.fieldsDisabled}
                  />
                </TableCell>
                <TableCell>Desde Cod</TableCell>
                <TableCell>Hasta Cod</TableCell>
                <TableCell>Categoria</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Galeno</TableCell>
                <TableCell>Gasto</TableCell>
                <TableCell style={{ width: "10%" }}>
                  Fecha Inicio Vigencia
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  Fecha Fin Vigencia
                </TableCell>
                {validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONVENIOS_PERMISOS.ADMINISTRAR)
                 && selected.length > 0 && <TableCell>
                <DeleteConveniosMasivosButton 
                //fechaInicioVigencia={filtroFecha}
                deletePracticas={deletePracticasActivasMasivasHandler}
                futura={filtroFecha === 3} />
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {practicasConfirmadas
                ?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((practica, index) => {
                  const isItemSelected = isSelected(practica.idGalenosGastos);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      key={practica.idGalenosGastos}
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      selected={isItemSelected}
                      className={classes.rootTableRow}
                    >
                      <TableCell padding="checkbox">
                          <Checkbox
                        checked={isItemSelected}
                        inputProps={{ "aria-labelledby": labelId }}
                        onClick={(event) => handleClick(event, practica.idGalenosGastos)}
                        disabled={props.fieldsDisabled || (practica.fechaReactivacionPermitida !== null && moment(practica.fechaReactivacionPermitida).isSame(moment(), 'day'))}
                      />                              
                      </TableCell>
                      <TableCell>{practica.codigoPracticaDesde}</TableCell>
                      <TableCell>{practica.codigoPracticaHasta}</TableCell>
                      <TableCell>
                        {CATEGORIAS_VALORIZACIONES_ARRAY.find(x => x.id === practica.idCategoria)?.descripcion}
                      </TableCell>
                      <TableCell>{practica.valor}</TableCell>
                      <TableCell>{practica.galeno?.descripcion}</TableCell>
                      <TableCell>{practica.idGasto !== 1 && practica.gasto?.descripcion}</TableCell>
                      <TableCell>
                        {new Date(
                          practica.fechaInicioVigencia
                        ).toLocaleDateString()}
                      </TableCell>
                      <TableCell>
                        {new Date(
                          practica.fechaFinVigencia
                        ).toLocaleDateString()}
                      </TableCell>
                      {
                        !props.fieldsDisabled &&
                        <TableCell>
                          <div style={{ display: "flex" }}>
                            {
                              !moment(practica.fechaFinVigencia).isBefore(moment(), 'day') &&
                              <EditConveniosButton idItem={practica.idGalenosGastos} item={practica} editItem={handleEditPractica} />
                            }
                            {
                              (practica.fechaReactivacionPermitida !== null && moment(practica.fechaReactivacionPermitida).isSame(moment(), 'day'))
                                ?
                                <ReactivarConveniosButton idItem={practica.idGalenosGastos} reactivarPractica={reactivarPracticaHandler} />
                                :
                                <DeleteConveniosButton idItem={practica.idGalenosGastos} fechaInicioVigencia={practica.fechaInicioVigencia} deletePracticas={deletePracticasActivasHandler} futura={moment().isBefore(practica.fechaInicioVigencia)} />
                            }
                          </div>
                        </TableCell>
                      }
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            className="paginador"
            count={practicasConfirmadas.length}
            rowsPerPageOptions={[20, 50, 100]}
            labelRowsPerPage="Filas por página"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} de ${count}`
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Card>
      </Grid>
    </Grid>
  );
};
